import React, { useState, useEffect } from "react";
import Header3 from "../components/Header3";
import Footer2 from "../components/Footer2";
import { Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "../AxiosInstance";
import { BASE_URL } from "../config/BaseUrls";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const books = [
  {
    title: ["Normal People", ""],
    genre: "Fiction",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    image: require("../pages/image/book1.png"),
  },
  {
    title: ["Normal People", ""],
    genre: "Crime",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    image: require("../pages/image/book2.png"),
  },
  {
    title: ["Normal People", ""],
    genre: "Fiction",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    image: require("../pages/image/book3.png"),
  },

  {
    image: require("../pages/image/book1.png"),
  },
  {
    image: require("../pages/image/book2.png"),
  },
  {
    image: require("../pages/image/book3.png"),
  },

  {
    image: require("../pages/image/book2.png"),
  },

  {
    image: require("../pages/image/book3.png"),
  },
  {
    image: require("../pages/image/book2.png"),
  },

  // Add more book data here as needed
];

const SuggestiveBooks = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const settings = {
    // dots: true, // Show dots for navigation
    infinite: true, // Infinite looping
    speed: 500, // Transition speed
    slidesToShow: 3, // Show 3 books at a time
    slidesToScroll: 1, // Move 1 book at a time
    draggable: true, // Allow drag functionality
    swipe: true, // Allow touch swipe
    arrows: false, // Hide default navigation arrows
    responsive: [
      {
        breakpoint: 580, // For screen widths <= 768px
        settings: {
          slidesToShow: 3.6, // Show 2 books at a time
          centerPadding: "20px", // Padding around the center item
        },
      },
      {
        breakpoint: 500, // For screen widths <= 768px
        settings: {
          slidesToShow: 3, // Show 2 books at a time
          centerPadding: "5px", // Padding around the center item
        },
      },
      {
        breakpoint: 450, // For screen widths <= 450px
        settings: {
          slidesToShow: 2.98, // Show 2.5 books at a time
          centerMode: true, // Center the active slide
          centerPadding: "1px", // Padding around the center item
        },
      },
      {
        breakpoint: 400, // For screen widths <= 450px
        settings: {
          slidesToShow: 2.1, // Show 2.5 books at a time
          centerPadding: "1px", // Padding around the center item
        },
      },
    ],
  };

  const [headings, setHeadings] = useState([]);
  const [booksByHeading, setBooksByHeading] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHeadings();
  }, []);

  const fetchHeadings = async () => {
    try {
      const response = await axios.get("api/v1/admin/getheading");
      setHeadings(response.data);
      await fetchAllBooks(response.data); // Automatically fetch books for all headings
      setLoading(false);
    } catch (error) {
      console.error("Error fetching headings:", error);
    }
  };

  const fetchAllBooks = async (headings) => {
    try {
      const allBooks = {};

      for (const heading of headings) {
        const response = await axios.get(`/api/v1/admin/${heading._id}`);
        allBooks[heading._id] = response.data; // Storing books under their respective heading ID
      }

      setBooksByHeading(allBooks);
    } catch (error) {
      console.error("Error fetching books:", error);
    }
  };

  const StarRating = ({ rating }) => {
    const totalStars = 5;

    return (
      <div>
        {Array.from({ length: totalStars }, (_, index) => (
          <span
            key={index}
            style={{
              fontSize: "21px",
              color: index < rating ? "#ffc107" : "#ddd", // Warning color for filled stars, light grey for empty stars
            }}
          >
            ★
          </span>
        ))}
      </div>
    );
  };

  // New State to Save Clicked Book
  const [selectedBook, setSelectedBook] = useState(null);

  const handleBookClick = (book) => {
    setSelectedBook(book); // Save the clicked book to state
    localStorage.setItem("selectedBookforreviews", JSON.stringify(book)); // Save it to localStorage
    navigate("/reviews"); // Navigate to reviews page
  };
  return (
    <>
      <div className="clieddnthalisug sugheder ">
        <Header3 />
      </div>
      <div className="alincenterawidth scalmin1">
        <div className="mx-sm-5 mlclint mt-sm-5 mt-4 mb-4">
          <div
            className="fw-bold textczoom11  mx-sm-5 mx-auto text-center text-sm-start ftzwork"
            style={{ fontSize: "28px" }}
          >
            Suggested Books for Book Duo
          </div>
          <div>
            {loading ? (
              <p className="text-center" style={{ height: "100vh" }}>
                Loading Books...
              </p>
            ) : (
              headings.map((heading) => (
                <div key={heading._id}>
                  <div
                    className=" mx-sm-5 mx-2 textczoom11  fontupcon fw-bold mt-5 "
                    style={{ color: "gray", fontSize: "26px" }}
                    // #FF543E
                  >
                    {/* < use */}
                    {/* Crime */}
                    {heading.title}
                  </div>
                  <div className="d-sm-flex d-none justzomag11 mlmrbook gap-xl-2 gap-1 align-items-center">
                    <div className="d-flex  flex-wrap jucfyy mx-2 gapbooks mt-3">
                      {/* {books.map((book, index) => ( */}
                      {booksByHeading[heading._id] &&
                      booksByHeading[heading._id].length > 0 ? (
                        booksByHeading[heading._id].map((book) => (
                          <Card
                            // key={index}
                            key={book._id}
                            className="border-0 align-items-center"
                            style={{ width: "" }}
                          >
                            <Card.Img
                              className="imgsizeddddd"
                              variant="top"
                              // src={book.image}
                              // src={book.coverImage}
                              src={`${BASE_URL}/uploadsbook/${book.coverImage}`}
                              style={{
                                width: "110px",
                                height: "160px",
                                cursor: "pointer",
                              }}
                              // onClick={() => navigate("/reviews")}
                              onClick={() => handleBookClick(book)}
                            />
                            <Card.Body
                              className=" p-0 "
                              style={{ marginTop: "-30px" }}
                            >
                              {/* <Card.Text
                  className=" w-100 fw-bold ftzgern fs-6 mt-1"
                  style={{
                    color: "#383838",
                  }}
                >
                  {book.eventDate}
                </Card.Text>
                <Card.Title
                  className=" w-100 fs-5 fw-bold ftztitle "
                  style={{
                    color: "#6D6D6D",
                  }}
                >
                  {book.title[0]} <br /> {book.title[1]}
                </Card.Title>

                <Card.Title
                  className=" ftzgern fs-6 fw-bold m-0 "
                  style={{
                    color: "#C9321F",
                  }}
                >
                  {book.eventType}
                </Card.Title>

                <Card.Title className=" fw-bold text-dark ftzgern fs-6 mt-5">
                  {book.ageGroup}
                </Card.Title>
                <div>
                  <button
                    className="rounded-1 mt-1 editbtitn fw600 ftzgern fs-5 text-center text-dark"
                    style={{
                      border: "1px solid #383838",
                      backgroundColor: "#F2F2F2",
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Edit
                  </button>
                </div> */}

                              <div>
                                <span
                                  className="mx-2  "
                                  style={{
                                    fontSize: "21px",
                                  }}
                                >
                                  {/* ★★★★☆ */}
                                  <StarRating rating={book.rating || 5} />
                                </span>
                              </div>
                            </Card.Body>
                          </Card>
                        ))
                      ) : (
                        <p>No books found under this heading.</p>
                      )}
                    </div>
                  </div>

                  {/* coursol */}
                  <div className=" my-4 jucfyy mx-0 d-sm-none d-block  ">
                    <Slider {...settings}>
                      {booksByHeading[heading._id] &&
                      booksByHeading[heading._id].length > 0 ? (
                        booksByHeading[heading._id].map((book) => (
                          <div
                            key={book._id}
                            className="d-flex justify-content-center"
                          >
                            <Card
                              key={book._id}
                              className="border-0 align-items-center"
                              style={{ width: "" }}
                            >
                              <Card.Img
                                className="imgsizeaaa"
                                variant="top"
                                // src={book.image}
                                // src={book.coverImage}
                                src={`${BASE_URL}/uploadsbook/${book.coverImage}`}
                                style={{
                                  width: "130px",
                                  height: "170px",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleBookClick(book)}
                              />
                              <Card.Body
                                className=" p-0 "
                                style={{ marginTop: "-30px" }}
                              >
                                {/* <Card.Text
                  className=" w-100 fw-bold ftzgern fs-6 mt-1"
                  style={{
                    color: "#383838",
                  }}
                >
                  {book.eventDate}
                </Card.Text>
                <Card.Title
                  className=" w-100 fs-5 fw-bold ftztitle "
                  style={{
                    color: "#6D6D6D",
                  }}
                >
                  {book.title[0]} <br /> {book.title[1]}
                </Card.Title>

                <Card.Title
                  className=" ftzgern fs-6 fw-bold m-0 "
                  style={{
                    color: "#C9321F",
                  }}
                >
                  {book.eventType}
                </Card.Title>

                <Card.Title className=" fw-bold text-dark ftzgern fs-6 mt-5">
                  {book.ageGroup}
                </Card.Title>
                <div>
                  <button
                    className="rounded-1 mt-1 editbtitn fw600 ftzgern fs-5 text-center text-dark"
                    style={{
                      border: "1px solid #383838",
                      backgroundColor: "#F2F2F2",
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Edit
                  </button>
                </div> */}

                                <div>
                                  <span
                                    className="mx-2  "
                                    style={{
                                      fontSize: "21px",
                                    }}
                                  >
                                    {/* ★★★★☆ */}
                                    <StarRating rating={book.rating || 5} />
                                  </span>
                                </div>
                              </Card.Body>
                            </Card>
                          </div>
                        ))
                      ) : (
                        <p>No books found under this heading.</p>
                      )}
                    </Slider>
                  </div>
                </div>
              ))
            )}
          </div>

          <div className="d-none">
            <div
              className=" mx-sm-5 mx-2 textczoom11 fontupcon fw-bold mt-5 "
              style={{ color: "gray", fontSize: "26px" }}
            >
              {/* < use */}
              Short Fantasy (&lt;250 Pages)
            </div>

            <div className="d-sm-flex d-none justzomag11 mlmrbook gap-xl-2 gap-1 align-items-center">
              <div className="d-flex  flex-wrap jucfyy mx-2 gapbooks mt-3">
                {books.map((book, index) => (
                  <Card
                    key={index}
                    className="border-0 align-items-center"
                    style={{ width: "" }}
                  >
                    <Card.Img
                      className="imgsize"
                      variant="top"
                      src={book.image}
                      style={{
                        width: "110px",
                        height: "160px",
                        cursor: "pointer",
                      }}
                      onClick={() => navigate("/reviews")}
                    />
                    <Card.Body className=" p-0 mt-1">
                      {/* <Card.Text
                  className=" w-100 fw-bold ftzgern fs-6 mt-1"
                  style={{
                    color: "#383838",
                  }}
                >
                  {book.eventDate}
                </Card.Text>
                <Card.Title
                  className=" w-100 fs-5 fw-bold ftztitle "
                  style={{
                    color: "#6D6D6D",
                  }}
                >
                  {book.title[0]} <br /> {book.title[1]}
                </Card.Title>

                <Card.Title
                  className=" ftzgern fs-6 fw-bold m-0 "
                  style={{
                    color: "#C9321F",
                  }}
                >
                  {book.eventType}
                </Card.Title>

                <Card.Title className=" fw-bold text-dark ftzgern fs-6 mt-5">
                  {book.ageGroup}
                </Card.Title>
                <div>
                  <button
                    className="rounded-1 mt-1 editbtitn fw600 ftzgern fs-5 text-center text-dark"
                    style={{
                      border: "1px solid #383838",
                      backgroundColor: "#F2F2F2",
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Edit
                  </button>
                </div> */}

                      <div>
                        <span
                          className="mx-2 text-warning "
                          style={{ fontSize: "21px" }}
                        >
                          ★★★★☆
                        </span>
                      </div>
                    </Card.Body>
                  </Card>
                ))}
              </div>
            </div>

            {/* coursol */}
            <div className=" my-4 jucfyy mx-0 d-sm-none d-block  ">
              <Slider {...settings}>
                {books.map((book, index) => (
                  <div key={index} className="d-flex justify-content-center">
                    <Card
                      key={index}
                      className="border-0 align-items-center"
                      style={{ width: "" }}
                    >
                      <Card.Img
                        className="imgsizeaaa"
                        variant="top"
                        src={book.image}
                        style={{ width: "130px", height: "170px" }}
                      />
                      <Card.Body className=" p-0 mt-1">
                        {/* <Card.Text
                  className=" w-100 fw-bold ftzgern fs-6 mt-1"
                  style={{
                    color: "#383838",
                  }}
                >
                  {book.eventDate}
                </Card.Text>
                <Card.Title
                  className=" w-100 fs-5 fw-bold ftztitle "
                  style={{
                    color: "#6D6D6D",
                  }}
                >
                  {book.title[0]} <br /> {book.title[1]}
                </Card.Title>

                <Card.Title
                  className=" ftzgern fs-6 fw-bold m-0 "
                  style={{
                    color: "#C9321F",
                  }}
                >
                  {book.eventType}
                </Card.Title>

                <Card.Title className=" fw-bold text-dark ftzgern fs-6 mt-5">
                  {book.ageGroup}
                </Card.Title>
                <div>
                  <button
                    className="rounded-1 mt-1 editbtitn fw600 ftzgern fs-5 text-center text-dark"
                    style={{
                      border: "1px solid #383838",
                      backgroundColor: "#F2F2F2",
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Edit
                  </button>
                </div> */}

                        <div>
                          <span
                            className="mx-2 text-warning"
                            style={{ fontSize: "21px" }}
                          >
                            ★★★★☆
                          </span>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                ))}
              </Slider>
            </div>
          </div>

          <div className="d-none">
            <div
              className=" mx-sm-5 mx-2 textczoom11  fontupcon fw-bold mt-5 "
              style={{ color: "gray", fontSize: "26px" }}
            >
              {/* < use */}
              Short novel (&lt;250 pages)
            </div>

            <div className="d-sm-flex d-none justzomag11 mlmrbook gap-xl-2 gap-1 align-items-center">
              <div className="d-flex  flex-wrap jucfyy mx-2 gapbooks mt-3">
                {books.map((book, index) => (
                  <Card
                    key={index}
                    className="border-0 align-items-center"
                    style={{ width: "" }}
                  >
                    <Card.Img
                      className="imgsize"
                      variant="top"
                      src={book.image}
                      style={{
                        width: "110px",
                        height: "160px",
                        cursor: "pointer",
                      }}
                      onClick={() => navigate("/reviews")}
                    />
                    <Card.Body className=" p-0 mt-1">
                      {/* <Card.Text
                  className=" w-100 fw-bold ftzgern fs-6 mt-1"
                  style={{
                    color: "#383838",
                  }}
                >
                  {book.eventDate}
                </Card.Text>
                <Card.Title
                  className=" w-100 fs-5 fw-bold ftztitle "
                  style={{
                    color: "#6D6D6D",
                  }}
                >
                  {book.title[0]} <br /> {book.title[1]}
                </Card.Title>

                <Card.Title
                  className=" ftzgern fs-6 fw-bold m-0 "
                  style={{
                    color: "#C9321F",
                  }}
                >
                  {book.eventType}
                </Card.Title>

                <Card.Title className=" fw-bold text-dark ftzgern fs-6 mt-5">
                  {book.ageGroup}
                </Card.Title>
                <div>
                  <button
                    className="rounded-1 mt-1 editbtitn fw600 ftzgern fs-5 text-center text-dark"
                    style={{
                      border: "1px solid #383838",
                      backgroundColor: "#F2F2F2",
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Edit
                  </button>
                </div> */}

                      <div>
                        <span
                          className="mx-2 text-warning "
                          style={{ fontSize: "21px" }}
                        >
                          ★★★★☆
                        </span>
                      </div>
                    </Card.Body>
                  </Card>
                ))}
              </div>
            </div>

            {/* coursol */}
            <div className=" my-4 jucfyy mx-0 d-sm-none d-block  ">
              <Slider {...settings}>
                {books.map((book, index) => (
                  <div key={index} className="d-flex justify-content-center">
                    <Card
                      key={index}
                      className="border-0 align-items-center"
                      style={{ width: "" }}
                    >
                      <Card.Img
                        className="imgsizeaaa"
                        variant="top"
                        src={book.image}
                        style={{ width: "130px", height: "170px" }}
                      />
                      <Card.Body className=" p-0 mt-1">
                        {/* <Card.Text
                  className=" w-100 fw-bold ftzgern fs-6 mt-1"
                  style={{
                    color: "#383838",
                  }}
                >
                  {book.eventDate}
                </Card.Text>
                <Card.Title
                  className=" w-100 fs-5 fw-bold ftztitle "
                  style={{
                    color: "#6D6D6D",
                  }}
                >
                  {book.title[0]} <br /> {book.title[1]}
                </Card.Title>

                <Card.Title
                  className=" ftzgern fs-6 fw-bold m-0 "
                  style={{
                    color: "#C9321F",
                  }}
                >
                  {book.eventType}
                </Card.Title>

                <Card.Title className=" fw-bold text-dark ftzgern fs-6 mt-5">
                  {book.ageGroup}
                </Card.Title>
                <div>
                  <button
                    className="rounded-1 mt-1 editbtitn fw600 ftzgern fs-5 text-center text-dark"
                    style={{
                      border: "1px solid #383838",
                      backgroundColor: "#F2F2F2",
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Edit
                  </button>
                </div> */}

                        <div>
                          <span
                            className="mx-2 text-warning"
                            style={{ fontSize: "21px" }}
                          >
                            ★★★★☆
                          </span>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                ))}
              </Slider>
            </div>
          </div>

          <div className="d-none">
            <div
              className=" mx-sm-5 mx-2 textczoom11  fontupcon fw-bold mt-5 "
              style={{ color: "gray", fontSize: "26px" }}
            >
              Feminism{" "}
            </div>

            <div className="d-sm-flex d-none justzomag11 mlmrbook gap-xl-2 gap-1 align-items-center">
              <div className="d-flex  flex-wrap jucfyy mx-2 gapbooks mt-3">
                {books.map((book, index) => (
                  <Card
                    key={index}
                    className="border-0 align-items-center"
                    style={{ width: "" }}
                  >
                    <Card.Img
                      className="imgsize"
                      variant="top"
                      src={book.image}
                      style={{
                        width: "110px",
                        height: "160px",
                        cursor: "pointer",
                      }}
                      onClick={() => navigate("/reviews")}
                    />
                    <Card.Body className=" p-0 mt-1">
                      {/* <Card.Text
                  className=" w-100 fw-bold ftzgern fs-6 mt-1"
                  style={{
                    color: "#383838",
                  }}
                >
                  {book.eventDate}
                </Card.Text>
                <Card.Title
                  className=" w-100 fs-5 fw-bold ftztitle "
                  style={{
                    color: "#6D6D6D",
                  }}
                >
                  {book.title[0]} <br /> {book.title[1]}
                </Card.Title>

                <Card.Title
                  className=" ftzgern fs-6 fw-bold m-0 "
                  style={{
                    color: "#C9321F",
                  }}
                >
                  {book.eventType}
                </Card.Title>

                <Card.Title className=" fw-bold text-dark ftzgern fs-6 mt-5">
                  {book.ageGroup}
                </Card.Title>
                <div>
                  <button
                    className="rounded-1 mt-1 editbtitn fw600 ftzgern fs-5 text-center text-dark"
                    style={{
                      border: "1px solid #383838",
                      backgroundColor: "#F2F2F2",
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Edit
                  </button>
                </div> */}

                      <div>
                        <span
                          className="mx-2 text-warning "
                          style={{ fontSize: "21px" }}
                        >
                          ★★★★☆
                        </span>
                      </div>
                    </Card.Body>
                  </Card>
                ))}
              </div>
            </div>

            {/* coursol */}
            <div className=" my-4 jucfyy mx-0 d-sm-none d-block  ">
              <Slider {...settings}>
                {books.map((book, index) => (
                  <div key={index} className="d-flex justify-content-center">
                    <Card
                      key={index}
                      className="border-0 align-items-center"
                      style={{ width: "" }}
                    >
                      <Card.Img
                        className="imgsizeaaa"
                        variant="top"
                        src={book.image}
                        style={{ width: "130px", height: "170px" }}
                      />
                      <Card.Body className=" p-0 mt-1">
                        {/* <Card.Text
                  className=" w-100 fw-bold ftzgern fs-6 mt-1"
                  style={{
                    color: "#383838",
                  }}
                >
                  {book.eventDate}
                </Card.Text>
                <Card.Title
                  className=" w-100 fs-5 fw-bold ftztitle "
                  style={{
                    color: "#6D6D6D",
                  }}
                >
                  {book.title[0]} <br /> {book.title[1]}
                </Card.Title>

                <Card.Title
                  className=" ftzgern fs-6 fw-bold m-0 "
                  style={{
                    color: "#C9321F",
                  }}
                >
                  {book.eventType}
                </Card.Title>

                <Card.Title className=" fw-bold text-dark ftzgern fs-6 mt-5">
                  {book.ageGroup}
                </Card.Title>
                <div>
                  <button
                    className="rounded-1 mt-1 editbtitn fw600 ftzgern fs-5 text-center text-dark"
                    style={{
                      border: "1px solid #383838",
                      backgroundColor: "#F2F2F2",
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Edit
                  </button>
                </div> */}

                        <div>
                          <span
                            className="mx-2 text-warning"
                            style={{ fontSize: "21px" }}
                          >
                            ★★★★☆
                          </span>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
      <Footer2 />
    </>
  );
};

export default SuggestiveBooks;
